import baseapi from "../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const DashboardAPI = async (setLoader, setTotalLeadCount, setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, setWarmCount, setTeamSummary, setIsStatReload) =>
{
      
    setLoader(true);

    try
    {
        const [statscount, teamsummarydatalist] = await Promise.all([
                                                                      baseapi.get("/api/sales/dashboard/summary"),
                                                                      baseapi.get("/api/sales/dashboard/team-performance")
                                                                ]);

        console.log("Data got successfully", statscount.data.totalleads);
        
        //setUsersList(response.data.data.data);
        setTotalLeadCount(statscount.data.totalleads);
        setFreshLeadCount(statscount.data.freshleads);
        setWarmCount(statscount.data.warmleads);
        setPendingFollowupCount(statscount.data.pendingfollowups);
        setTodayFollowupCount(statscount.data.todayfollowups);
        setTeamSummary(teamsummarydatalist.data.datalist);
        setLoader(false);
        setIsStatReload(false);

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        setLoader(false);
    }
}

export const getTeamsAPI = async (setTeams) =>
{
      

    try
    {
        const response = await baseapi.get('api/sales/teams');

        //console.log("Data got successfully", response.data.usercount);
        
        //setUsersList(response.data.data.data);
        setTeams(response.data.datalist);
        //return response;

        

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        
    }
}

export const DashboardTeamFilterAPI = async (setNewLeadCount, setPendingFollowupCount, setTodayFollowupCount, params) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.post('api/sales/dashboard-team-filter', params);

        //console.log("Data got successfully", response);

        setNewLeadCount(response.data.freshleads);
        setPendingFollowupCount(response.data.totalfollowup);
        setTodayFollowupCount(response.data.dashboard.todayfollowup);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        
        errorMesg("Lead has not been added. Please try again!!!");
    }
}

/*export const getTeamCampaignListAPI = async (teamid, setCampaigns) =>
{
    try
    {
        const response = await baseapi.get('api/sales/filter/campaigns/' + teamid);

        //console.log("Data got successfully", response.data.usercount);
        
        //setUsersList(response.data.data.data);
        setCampaigns(response.data.datalist);
        //return response;

        

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        
    }
}*/

export const getFilterCallerListAPI = async (teamid, setCallers) =>
{
    try
    {
        const response = await baseapi.get('api/sales/filter/callers/' + teamid);

        //console.log("Data got successfully", response.data.usercount);
        
        //setUsersList(response.data.data.data);
        setCallers(response.data.datalist);
        //return response;

        

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        
    }
}

export const DashboardFilterAPI = async (filterparams, setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, setWarmCount, setFilterParam) =>
{
      
    let searchparam = "";

    if(filterparams !== "" && filterparams !== null && filterparams !== undefined)
    {
        searchparam = `?${filterparams.toString()}`;
    }
    else
    {
        searchparam = "";
    }

    try
    {
        const response = await baseapi.get('api/sales/dashboard' + searchparam);

        console.log("Data got successfully", response.data.warmleads);
        
        //setUsersList(response.data.data.data);
        setFreshLeadCount(response.data.freshleads);
        setPendingFollowupCount(response.data.pendingfollowups);
        setTodayFollowupCount(response.data.todayfollowups);
        setWarmCount(response.data.warmleads);
        //setNotifications();
        //return response;
        setFilterParam('?' + filterparams);
        

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        
    }
}

export const CallerDataAPI = async (setCallerData, teamid, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    let txtsearchparam = "";

    txtsearchparam = "?page=" + currentPage + "&per_page=" + perpagedata;

    try
    {
        const response = await baseapi.get('api/sales/team/' + teamid+ '/caller-report' + txtsearchparam);

        console.log("Data got successfully", response.data.datalist);
        
        //setUsersList(response.data.data.data);
        setCallerData(response.data.datalist);
        setLoading(false);
        //setNotifications();
        //return response;

        /*if(response.data.callerlist.data.length > 0)
        {
            console.log('Total count====='+response.data.callerlist);
            let pagecount = Math.ceil(response.data.callerlist / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }*/

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        setLoading(false);
    }
}

